import { Link } from 'react-router-dom';
import { latestVideos } from '@/mocks/videos';

export default function LatestVideos() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                最新视频
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                实时更新 · 最新发布的视频内容
              </p>
            </div>
            <Link
              to="/category/latest-news"
              className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {latestVideos.map((video, idx) => (
              <Link
                key={video.id}
                to={`/article/${video.slug}`}
                className="group bg-background-100 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
                  <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded-md font-medium">
                    {video.duration}
                  </span>
                  {idx === 0 && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs rounded-full font-medium">
                      最新
                    </span>
                  )}
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full font-medium">
                      {video.category}
                    </span>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {video.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                    {video.excerpt}
                  </p>
                  <div className="flex items-center justify-between mt-4">
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <span className="w-3.5 h-3.5 flex items-center justify-center">
                          <i className="ri-eye-line"></i>
                        </span>
                        {video.views}
                      </span>
                      <span>{video.date}</span>
                    </div>
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className="ri-play-fill text-sm"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-8 text-center sm:hidden">
            <Link
              to="/category/latest-news"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部视频
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}